import axios from 'axios';
import apiConfig from '../../api.config';

export default function getHotelCheckinConfig({ hotelId}) {
    // update ALL hotel checkin config

  const {
    host,
    URIs: { getHotelCheckinConfig }, 
  } = apiConfig;

  const uri = `${host}${getHotelCheckinConfig}`.replace(':hotelId', hotelId);

  return axios
    .get(uri, {
    })
    .then(res => {
      return res.data;
    });
}
